import {createBrowserHistory} from 'history'
import {useSearchParam} from "react-use";

const history = createBrowserHistory()

export default history

export const useRouteSearchParam = useSearchParam

export const getRouteSearchParams = () => {
  return new URLSearchParams(window.location.search);
};
export const copyLocationParam = (location) => {
  return location ?? {}
}
export const getRoutePathParams = () => {
  return window.location.pathname;
};
export const routePathStartsWith = (location, routePathname) => {
  return location?.pathname?.startsWith(routePathname)
}

export const refreshToken = () => {
  const searchParams = getRouteSearchParams();
  searchParams.set('refresh_token', Date.now());
  history.replace({
    ...copyLocationParam(window.location ?? {}),
    pathname: window.location.pathname,
    search: '?' + searchParams.toString(),
  });
}